import React from 'react';

const Uganda1_kindergarten_envir = () => {
  return (
    <div>
      
    </div>
  );
}

export default Uganda1_kindergarten_envir;
